import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import ProductSectionForm from 'ui-shared/Forms/ProductSectionForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const LocationSectionEdit: React.FC = () => (
  <SectionWrapper title={'resources.locationsections.editSection'}>
    <Edit>
      <ProductSectionForm
        entity="locations"
        toolbar={<WithDeleteModalToolbar />}
      />
    </Edit>
  </SectionWrapper>
)

export default LocationSectionEdit
